import SideImg from "./sideImage/sideImg";
import SideText from "./sideText/sideText";
import Navbar from "./sideText/navbar/navbar";


function Main() {
    return(
      <main className="container">
        <Navbar/>
        <SideImg/>
        <SideText/>
      </main>

    )
}
export default Main